import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col font-sans text-brandtext bg-brandbg" data-id="element-79">
      <Navbar data-id="element-80" />
      <main className="flex-grow flex flex-col w-full" data-id="element-81">{children}</main>
      <Footer data-id="element-82" />
    </div>;
}